import { c } from "react-compiler-runtime";
import { useEffect } from "react";
const useDropdownButtonPosition = (t0)=>{
    const $ = c(5);
    const { contextRef, dropDownRef, editor } = t0;
    let t1;
    let t2;
    if ($[0] !== contextRef || $[1] !== dropDownRef || $[2] !== editor) {
        t1 = ()=>{
            const menuButtonElement = contextRef.current;
            const dropDownElement = dropDownRef.current;
            const rootElement = editor.getRootElement();
            if (null != menuButtonElement && null != dropDownElement && null != rootElement) {
                const rootEleRect = rootElement.getBoundingClientRect();
                const menuButtonRect = menuButtonElement.getBoundingClientRect();
                dropDownElement.style.opacity = "1";
                const dropDownElementRect = dropDownElement.getBoundingClientRect();
                let leftPosition = menuButtonRect.right + 5;
                if (leftPosition + dropDownElementRect.width > window.innerWidth || leftPosition + dropDownElementRect.width > rootEleRect.right) {
                    const position = menuButtonRect.left - dropDownElementRect.width - 5;
                    leftPosition = (position < 0 ? 5 : position) + window.pageXOffset;
                }
                dropDownElement.style.left = `${leftPosition + window.pageXOffset}px`;
                let topPosition = menuButtonRect.top;
                if (topPosition + dropDownElementRect.height > window.innerHeight) {
                    const position_0 = menuButtonRect.bottom - dropDownElementRect.height;
                    topPosition = position_0 < 0 ? 5 : position_0;
                }
                dropDownElement.style.top = `${topPosition}px`;
            }
        };
        t2 = [
            contextRef,
            dropDownRef,
            editor
        ];
        $[0] = contextRef;
        $[1] = dropDownRef;
        $[2] = editor;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    useEffect(t1, t2);
};
export { useDropdownButtonPosition };
